const langSBNavigation = {
  init: () => {},
  toggleMenu: (menuId, direction = 'open') => {
    const menu = document.getElementById(menuId);
    if (menu === null) {
      return;
    }

    if (direction === 'close') {
      document.body.classList.remove('menu-is-open');
      menu.setAttribute('aria-expanded', 'false');
    } else {
      document.body.classList.add('menu-is-open');
      menu.setAttribute('aria-expanded', 'true');
    }
  },
};

export default langSBNavigation;
